module.exports = __webpack_public_path__ + "static/media/mail.fe800925.svg";